import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { apiErrorMessage, loginAdmin, normalizeResponseData } from "../../core/api/adminApi";
import { useAuth } from "../../core/auth/AuthContext";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setSession } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await loginAdmin(email, password);
      const payload = normalizeResponseData(response);
      const token = payload?.token;
      if (!token) {
        setError("Login fehlgeschlagen: kein Token in Antwort.");
        return;
      }
      setSession(token, email);
      navigate("/dashboard");
    } catch (e) {
      setError(`Login fehlgeschlagen: ${apiErrorMessage(e)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>Login</h1>
        <p className="muted">Admin-Zugang erforderlich.</p>
        <form onSubmit={onSubmit} className="form-grid">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <label htmlFor="password">Passwort</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />

          <button type="submit" className="primary" disabled={loading}>
            {loading ? "Login läuft..." : "Login"}
          </button>
        </form>
        {error ? <div className="error-box">{error}</div> : null}
      </div>
    </div>
  );
}
